import { IFile } from 'declarations/file';
import { makeAutoObservable } from 'mobx';

export class FileStore {

  values: Array<IFile> = [];
  selected: any = {};
  fetchInProgress = false;
  saveInProgress = false;
  deleteInProgress = false;

  constructor() {
    makeAutoObservable(this);
  }

  addValues(values: Array<IFile>): void {
    this.values = values;
  }

  removeValue(resource_id: number): void {
    this.values = this.values.filter((item: IFile) => item.id != resource_id);
  }

  addSelectedValue(value: any): void {
    this.selected = value;
  }

  clearValues(): void {
    this.values = [];
  }

  updateValue(value: IFile): void {
    this.values = this.values.map((item: IFile) => item.id != value.id ? item : value)
  }
  setFetchInProgress(val: boolean) {
    this.fetchInProgress = val;
  }
  setSaveInProgress(val: boolean) {
    this.saveInProgress = val;
  }
  setDeleteInProgress(val: boolean) {
    this.deleteInProgress = val;
  }
}

export default (new FileStore())

